import React from 'react';
import Link from 'next/link';
import footerDataJson from '../Footer/footer.json';
import './globalFooter.scss';

declare global {
  interface Window {
    truste?: {
      types?: unknown;
      eu?: {
        clickListener?: () => void;
      };
      [key: string]: unknown;
    };
  }
}

type GlobalFooterProps = Partial<{
  contactIBM: string;
  contactIBMLink: string;
  privacyName: string;
  privacyLink: string;
  termsOfUseName: string;
  termsOfUseLink: string;
  accessibilityName: string;
  accessibilityLink: string;
  cookieName: string;
  cookieLink: string;
}>;

function GlobalFooter(props: GlobalFooterProps) {
  // Use JSON defaults if props are not provided
  const footer = footerDataJson.globalFooter;

  return (
    <div id="developer-IBM-global-footer">
      <ul id="global-footer-row">
        {/** Community link */}
        { (props.contactIBM || footer.contactIBM) && (
          <li>
            <Link href={props.contactIBMLink || footer.contactIBMLink}>
              {props.contactIBM || footer.contactIBM}
            </Link>
          </li>
        )}

        {/** Privacy */}
        <li>
          <Link href={props.privacyLink || footer.privacyLink}>
            {props.privacyName || footer.privacyName}
          </Link>
        </li>

        {/** Terms of Use */}
        <li>
          <Link href={props.termsOfUseLink || footer.termsOfUseLink}>
            {props.termsOfUseName || footer.termsOfUseName}
          </Link>
        </li>

        {/** Accessibility */}
        <li>
          <Link href={props.accessibilityLink || footer.accessibilityLink}>
            {props.accessibilityName || footer.accessibilityName}
          </Link>
        </li>

        {/** Cookie */}
        {/* <li>
          <Link
            href={props.cookieLink || footer.cookieLink || '#'}
            onClick={e => {
              if (!props.cookieLink && !footer.cookieLink) return;
              e.preventDefault();
              window.truste?.eu?.clickListener?.();
            }}
          >
            {props.cookieName || footer.cookieName}
          </Link>
        </li> */}
      </ul>
    </div>
  );
}

export default GlobalFooter;